<script>
/*jshint esversion: 6 */
import { computed, watch, inject } from 'vue';
import './../func.common';
import { FontAwesomeIcon, FontAwesomeLayers} from "@fortawesome/vue-fontawesome";

export default{
    name: 'Checkbox',
    components: {
        'font-awesome-icon' : FontAwesomeIcon,
        'font-awesome-layers': FontAwesomeLayers
    },
    props: {
		'hinted': {type:String},
        'disabled': {type: Boolean},
        'hinted': {type: String},
        'id': { type: String, default: ''}, 
        'model': { type: [Object], default: function() { return {};} }, 
        'schema': { type: [Object], default: function() { return {};} }, 
        'schemaId': {type: Number, default: 0}, 
    },
    setup(props) {
        const validateChild = inject('validateChild');
        const helperName = computed(() => {
            return props.model[props.schema.model];
        });

        watch(helperName, (newVal, oldVal) => {
            var toParent = {
                'id': props.schemaId,
                'model': props.schema.model,
                'validator': props.schema.validator,
            };
            
            if (validateChild) {
                validateChild(toParent);
            }
        });

        return {
            helperName
        };
    }
};
</script>
<template lang="pug">
.vueFormFieldMain
    .checkBoxField(:class="[schema.class, disabled === true ? 'fieldDisabled': '']")
        .form-group.row.gy-2.gx-3-align-items-left
            .col-sm-12
                label(
                    :for="id" 
                    v-if="schema.label && schema.label.length > 0"
                )  
                    | {{ schema.label }}
                    span.redAst(v-if="schema.required === true") *
        .fieldCheckbox(:style="disabled === true ? 'opacity: 0.5; cursor: not-allowed' : ''" )
            .form-group.row.gy-2.gx-3-align-items-left
                .col-12(
                    :style="disabled === true ? 'cursor:not-allowed' : ''"  
                    :class="schema.checkBoxType === 'custom' ? 'checkBoxCustom': ''"
                )
                    input(
                        type="checkbox" 
                        :id="`${id}`"
                        v-model="model[schema.model]"
                        :class="schema.errorShow === true ? 'inputred' : ''"
                        :style="disabled === true ? `pointer-events:none; display:${schema.boxInput}`: `display:${schema.boxInput}`"
                    ) 
                    label.smallLabel.d-flex.justify-content-start(
                        :for="`${id}`"
                        :style="disabled === true ? 'pointer-events:none': ''"
                    ) 
                        .col-auto
                            span.squareBorder(
                                :class="schema.borderClass" :style="`margin-right:${schema.marginBetween};position:relative; top:${schema.boxTop}px; font-size:${schema.boxFontSize}; border: ${schema.boxBorder}; border-radius:${schema.boxBorderRadius}px;padding:${schema.boxPadding};background:${schema.boxBackground};color:${schema.colorContent}`"
                                v-if="schema.checkBoxType !== 'custom'"
                            )
                                font-awesome-icon(v-if="schema.checkBoxType === 'squareRound'" icon="fa-solid fa-square" :style="[model[schema.model] === false ? 'opacity:0' : '']")
                                font-awesome-icon(v-if="schema.checkBoxType === 'squareAngular'" icon="fa-solid fa-square-full" :style="[model[schema.model] === false ? 'opacity:0' : '']")
                                font-awesome-icon(v-if="schema.checkBoxType === 'squareHook'" icon="fa-solid fa-check" :style="[model[schema.model] === false ? 'opacity:0' : '']")
                                font-awesome-icon(v-if="schema.checkBoxType === 'squareCross'" icon="fa-solid fa-xmark" :style="[model[schema.model] === false ? 'opacity:0' : '']")
                        div(:class="schema.checkBoxText")  {{ schema.boxLabel }}
            .hint(v-if="hinted && hinted.length > 0" v-html="hinted") 
            .vueFormSmall.labelred(v-if="schema.errorShow === true")
                font-awesome-icon(icon="fa-solid fa-exclamation" class="errorExclamationMarkColor") 
                |  {{ schema.errorText[0] }}
</template>